var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_237",
    "data-name": "Group 237",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.44,
    height: 16.293,
    viewBox: "0 0 24.44 16.293",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M23.187,85.333H1.253A1.257,1.257,0,0,0,0,86.586v13.787a1.257,1.257,0,0,0,1.253,1.253H23.187a1.257,1.257,0,0,0,1.253-1.253V86.586A1.257,1.257,0,0,0,23.187,85.333Zm-.47.94-9.775,7.332a1.31,1.31,0,0,1-1.442,0L1.724,86.273Zm-5.222,7.816,5.327,6.58c.005.007.012.012.018.018H1.6c.006-.006.012-.011.018-.018l5.327-6.58a.47.47,0,0,0-.731-.592L.94,100.013V86.86l10,7.5a2.243,2.243,0,0,0,2.569,0l10-7.5v13.152L18.225,93.5a.47.47,0,0,0-.731.592Z",
    transform: "translate(0 -85.333)",
    fill: "gray"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.e2c6a67e92d2fc69d0098a5cec296986.svg";
export { ForwardRef as ReactComponent };